// extracted by mini-css-extract-plugin
module.exports = {"header":"dece2e673c--header--DMmWA"};